/**************************************************
 * Nombre:       Formacion_Resolucion_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import resolucion from '../../../Recursos/Iconos/ic_resolucion.svg'
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import Tarjeta_Formacion_Item from "../../Tarjetas/Tarjeta_Formacion_Item";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Informacion from "../../Formularios/Formulario_Informacion";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Formacion_Resolucion_Informacion = ({item}) => {
    const {sCell} = useResponsive()
    const {props} = useFormulario({valoresDefecto: {}})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      spacing={8}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        spacing={0}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 8}}
                            sx={{mt: 0}}
                        >

                            <Grid container size={{xs: 2, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                                <img src={resolucion} width={'90%'} height={'auto'}/>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 10, sm: 12, md: 10}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            color: theme.palette.primary.main,
                                            fontSize: sCell ? 16 : 18,
                                            fontWeight: 600
                                        }}>Descargar</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: sCell ? 24 : 28, fontFamily: NEGRITA, lineHeight: 1.1}}>
                                        Broshure del programa
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 8}}>
                            <Typography
                                sx={{fontSize: sCell ? 32 : 40, fontFamily: NEGRITA, lineHeight: 1.1, fontWeight: 600}}>
                                Información del programa
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography
                                sx={{fontSize: 18, lineHeight: 1.3}}>
                                {item.informacion}
                            </Typography>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={3}
                            sx={{mt: 8}}
                        >

                            {item && item.items && item.items.map((it, index) => (
                                <Grid key={index + 'w92'} container size={{xs: 6, sm: 12, md: 6}}
                                      sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Formacion_Item item={it}/>
                                </Grid>
                            ))}

                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        sx={{mt: sCell ? 2 : 10}}
                    >

                        <Formulario_Informacion props={props}/>

                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Resolucion_Informacion

const items = [1, 2, 3, 4, 5, 6]